// Configuration variables for the frontend application

// API URL - use environment variable or fallback to localhost
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Other configuration variables can be added here
export const APP_NAME = 'WMS 3PL';
export const APP_VERSION = '1.0.0';

// Feature flags
export const FEATURES = {
  enableInventoryHistory: false,
  enableAdvancedFilters: true,
  enableBulkOperations: false,
  enableAutomaticAlerts: false
}; 
